"use client";

import { useNavigation } from "@/context/NavigationContext";

export default function LoadingBar() {
  const { isPending } = useNavigation();

  return (
    <div className="relative">
      {isPending && (
        <div className="loading-bar fixed top-0 left-0 right-0 h-1 bg-primary transition-all ease-in-out duration-500">
          {/* You can add animation or a progress effect here */}
        </div>
      )}
    </div>
  );
}